// import moment from 'moment';
import React, { FunctionComponent, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
// import { meetingInfoSelectors } from '../../../../app/resource/meeting-info/meeting-info.selectors';

// import { IMeeting } from '../../../../app/resource/meeting/meeting.types';
import { userGroupSelectors } from '../../../../app/resource/user-group/user-group.selectors';
import { IUserUpdateForm } from '../../../../app/resource/user/user.types';
import { getValidTimezones } from '../../../../utils/date.utils';
import { useRequiredValidation, usePhoneNumberValidation } from '../../../../utils/form/validation.utils';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { AvatarInput } from '../../common/inputs/AvatarInput';
import { SelectInput } from '../../common/inputs/SelectInput';
import { FormTextInput } from '../../common/inputs/TextInput';
import { PhoneInputField } from '../../common/inputs/PhoneInput';
import { IUserFormProps } from './types';
import { FormCheckboxInput } from '../../common/inputs/CheckboxInput';
import { DateTimeInput } from '../../common/inputs/DateTimeInput';

export const UserForm: FunctionComponent<IUserFormProps> = ({ data, onSubmit }) => {
  const formProps = useForm();
  const requiredValidation = useRequiredValidation();
  const validPhoneNumberValidation = usePhoneNumberValidation();

  // const meetings = useSelect(meetingInfoSelectors.selectResourceList);
  const userGroups = useSelect(userGroupSelectors.selectResourceList);

  // const { teamsOptions, accountsOptions } = useMemo(
  //   () => ({
  //     teamsOptions: meetings
  //       .filter((meeting) => meeting.type !== 'account')
  //       .map((team) => ({
  //         value: team.id,
  //         label: team.title,
  //       })),
  //     accountsOptions: meetings
  //       .filter((meeting) => meeting.type === 'account')
  //       .map((team) => ({
  //         value: team.id,
  //         label: team.title,
  //       })),
  //   }),
  //   [meetings],
  // );

  const groupOptions = useMemo(
    () =>
      userGroups.map((group) => ({
        value: group.id,
        label: group.name,
      })),
    [userGroups],
  );

  // const teamsDefaultValues = useSelectWithParams(meetingSelectors.selectResourcesById, data ? data.teams : []);
  // const teamsDefaultValues = useSelectWithParams(
  //   meetingInfoSelectors.selectResourcesById,
  //   data && data?.teamIds.length >= 1 ? data.teamIds : [],
  // );
  const groupsDefaultValues = useSelectWithParams(
    userGroupSelectors.selectResourcesById,
    data && data.groupIds && data.groupIds.length >= 1 ? data.groupIds : [],
  );

  const groupsDefaultOptions = useMemo(() => {
    const groups = groupsDefaultValues.map((group) => ({
      value: group ? group.id : '0',
      label: group ? group.name : '',
    }));
    return groups.length !== 0 ? groups : undefined;
  }, [groupsDefaultValues]);

  // const teamsDefaultOptions = useMemo(() => {
  //   const meetings = (teamsDefaultValues.filter((team) => !!team) as IMeeting[]).map((team) => ({
  //     value: team.id,
  //     label: team.title,
  //   }));
  //   return meetings.length !== 0 ? meetings : undefined;
  // }, [teamsDefaultValues]);

  // const timezones = moment.tz.names();
  // const timezonesPST = [
  //   'Pacific/Honolulu',
  //   'America/Anchorage',
  //   'America/Los_Angeles',
  //   'America/Phoenix',
  //   'America/Mexico_City',
  //   'America/New_York',
  //   'America/Halifax',
  //   'America/Sao_Paulo',
  // ];
  // const timezoneOptions = useMemo(
  //   () =>
  //     timezonesPST.map((timezone) => ({
  //       value: timezone,
  //       label: moment.tz(timezone).format('Z z').concat(' ', timezone),
  //     })),
  //   [timezonesPST],
  // );
  // console.log('TIMEZONES: ', timezones);

  const timezones = getValidTimezones();

  const timezoneOptions = useMemo(
    () =>
      timezones.map((timezone) => ({
        value: timezone.value,
        label: timezone.label,
      })),
    [timezones],
  );

  const timezoneDefaultOptions = useMemo(
    () => timezoneOptions.filter((timezone) => data && timezone.value === data.timezone),
    [data, timezoneOptions],
  );
  const selectedTimezone = timezoneDefaultOptions[0];

  // const timezonesPST = [moment.tz('Pacific/Honolulu').format('Z z'), moment.tz('America/New_York').format('Z z')];

  // const dobDefaultValue = data?.dob;

  // const date = useMemo(() => {
  //   try {
  //     if (dobDefaultValue) {
  //       const dateString = new Date(moment(dobDefaultValue).format('YYYY-MM-DD'));
  //       return dateString;
  //     } else {
  //       return new Date(moment().format('YYYY-MM-DD'));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }, [dobDefaultValue]);

  return (
    <FormProvider {...formProps}>
      <form
        id="user-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as IUserUpdateForm, data?.id))}
        action=""
        method="post"
      >
        <div className="col-12" style={{ marginTop: '10px' }}>
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.firstName}
              id="firstName"
              name="firstName"
              type="text"
              label="First Name (*)"
              placeholder="Enter First Name"
              validation={requiredValidation}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.lastName}
              id="lastName"
              name="lastName"
              type="text"
              label="Last Name (*)"
              placeholder="Enter Last Name"
              validation={requiredValidation}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.email}
              id="email"
              name="email"
              type="email"
              label="Email (*)"
              placeholder="Enter Email"
              validation={requiredValidation}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.jobTitle}
              id="jobTitle"
              name="jobTitle"
              type="text"
              label="Job Title"
              placeholder="Enter Job Title"
            />
          </div>
        </div>
        <div className="flex">
          <div className="col-6">
            <div className="field-container">
              <DateTimeInput
                defaultValue={data?.dateOfBirth}
                id="dateOfBirth"
                name="dateOfBirth"
                label="Date of Birth"
                placeholder="Enter Date of Birth"
              />
            </div>
          </div>
          <div className="col-6">
            <div className="field-container">
              <PhoneInputField
                defaultValue={data?.phone}
                id="phone"
                name="phone"
                label="Phone Number"
                placeholder="Enter Phone Number"
                defaultCountry="US"
                validation={validPhoneNumberValidation}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <SelectInput
              defaultOptions={selectedTimezone}
              id="timezone"
              name="timezone"
              label="Timezone"
              placeholder="Enter Timezone"
              options={timezoneOptions}
              // validation={requiredValidation}
              isSingle
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.address}
              id="address"
              name="address"
              type="text"
              label="Address"
              placeholder="Enter Address"
              // validation={requiredValidation}
            />
          </div>
        </div>
        {/* <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.alternativeAddress}
              id="alternativeAddress"
              name="alternativeAddress"
              type="text"
              label="Alternative Address"
              placeholder="Enter Alternative Address"
            />
          </div>
        </div> */}
        {/* <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.alternativePhone}
              id="alternativePhone"
              name="alternativePhone"
              type="text"
              label="Alternative Phone"
              placeholder="Enter Alternative Phone"
            />
          </div>
        </div> */}
        {/* <div className="col-12">
          <div className="field-container">
            <DateTimeInput
              defaultValue={date}
              id="dob"
              name="dob"
              label="Date of Birth"
              placeholder="Enter Date of Birth"
              // validation={requiredValidation}
            />
          </div>
        </div> */}
        {/* <div className="col-12">
          <div className="field-container">
            <SelectInput
              defaultOptions={teamsDefaultOptions}
              id="team_ids"
              name="team_ids"
              label="Teams"
              placeholder="Search Teams"
              options={teamsOptions}
            />
          </div>
        </div> */}

        <div className="col-12">
          <div className="field-container">
            <SelectInput
              // defaultOptions={teamsDefaultOptions}
              id="group_ids"
              name="group_ids"
              label="Directory groups"
              placeholder="Select directory groups"
              options={groupOptions}
              // validation={requiredValidation}
              defaultOptions={groupsDefaultOptions}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="field-container mt-3 flex aic jcl">
            <FormCheckboxInput id="isAdmin" name="isAdmin" defaultChecked={data?.isAdmin === '1'} />
            <label htmlFor="isAdmin" style={{ marginBottom: '13px', position: 'relative' }}>
              Is admin
            </label>
          </div>
        </div>

        {/* <div className="col-12">
          <div className="field-container">
            <FormTextInput
              defaultValue={data?.skype}
              id="skype"
              name="skype"
              type="text"
              label="Skype"
              placeholder="Enter SkypeID"
            />
          </div>
        </div> */}
        <div className="popup-upload-panel">
          {/* <ImageInput
            defaultValue={data?.image}
            id="image"
            name="image"
            label={`Upload Contact Photo`}
            maxImageSize={2}
            acceptableFormats={'jpg, png, gif'}
            // validation={requiredValidation}
          /> */}
          <AvatarInput
            defaultValue={data?.image}
            id="image"
            name="image"
            label={`Upload user photo`}
            maxImageSize={2}
            acceptableFormats={'jpg, png, gif, webp'}
          />
        </div>
        <div className="col-12 mt-2">
          <div className="darkGray">(*) mandatory fields</div>
        </div>
      </form>
    </FormProvider>
  );
};
